import cx from 'classnames';
import PropTypes from 'prop-types';

import { ReadonlyHtmlEditor } from 'src/components/RichSlate';

import { useStyles } from './useStyles';

export const ReadonlyStructure = ({ className, structureHtml, placeholder, singleLine }) => {
  const styles = useStyles();

  return (
    <ReadonlyHtmlEditor
      className={cx(styles.root, className, {
        [styles.singleLine]: singleLine,
      })}
      classes={{
        editable: styles.editable,
      }}
      html={structureHtml}
      placeholder={placeholder}
    />
  );
};

ReadonlyStructure.propTypes = {
  className: PropTypes.string,
  structureHtml: PropTypes.string,
  placeholder: PropTypes.string,
  singleLine: PropTypes.bool,
};

ReadonlyStructure.defaultProps = {
  className: null,
  structureHtml: null,
  placeholder: null,
  singleLine: false,
};
